import { render } from "./ArrowDown.vue?vue&type=template&id=00a60fd2"
const script = {}

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__